module.exports = __webpack_public_path__ + "img/aboutUs3.0f5061d.png";